<template>
    <div>
        <crud-table :actions="actions" title-icon="mdi-file-export-outline" hide-create show-search search-placeholder="ابحث باسم الملف" server-pagination :page-count="files.meta.last_page" :current-page="files.meta.current_page" :total="files.meta.total" :per-page="files.meta.per_page" title="الملفات المستخرجة" :items="filesItemsComputed" :headers="headers" @image="openUpdateImageDialog" @edit="openEditDialog" @delete="openDeleteDialog" @load="loadMore" @search="search" @reset="reset" />

        <!-- <action-dialog v-model="editDialog" action="put" :url="`/export-files/${editedItem.id}`" success-msg="تم حفظ التغييرات بنجاح" title="تعديل الملف" button-text="حفظ" :data="{name: editedItem.name}" @reset="resetEditForm" @sync="syncItem">
            <v-text-field v-model="editedItem.name" autofocus label="اسم الملف"></v-text-field>
        </action-dialog> -->

        <action-dialog v-model="deleteDialog" action="delete" :url="`/export-files/${deleteExportFile ? deleteExportFile.id : ''}`" title="حذف الملف" button-text="تأكيد الحذف" button-color="error" @sync="deleteItem(deleteExportFile.id)">
            <div v-if="deleteExportFile">
                <p class="strong-text--text">
                    هل أنت متأكد من حذف الملف <b class="strong-text--text">"{{deleteExportFile.name}}"</b> ؟
                </p>
            </div>
        </action-dialog>
    </div>
</template>

<script>
import CrudTable from '@/components/default/crud-table'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        CrudTable,
    },
    props: {
        files: {},
    },
    data() {
        return {
            page_url: '/export-files',

            editDialog: false,
            editedItem: {
                id: null,
                name: '',
            },

            updateImageDialog: false,
            updateImageId: null,
            updateImage: null,

            createDialog: false,
            newExportFile: {
                name: '',
                image: null,
                file: null,
            },

            deleteDialog: false,
            deleteExportFile: null,

            filesItems: null,

            headers: [
                {
                    text: 'عمليات',
                    value: 'actions',
                    sortable: false
                },
                /* {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                }, */
                {
                    text: 'عملية الاستخراج',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'الملف',
                    align: 'center',
                    sortable: false,
                    value: 'download',
                    externalLink: 'url',
                    target: '_self',
                    icon: 'mdi-download',
                    color: 'green darken-1'
                },
                {
                    text: 'وقت الاستخراج',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    computed: {
        filesItemsComputed(){
            return this.filesItems.map(file=>{
                return {
                    ...file,
                    download: 'تحميل الملف',
                }
            });
        },
        actions(){
            let actions = [
                // {name: 'edit', text: 'تعديل', icon: 'mdi-pencil'},
                {name: 'delete', text: 'حذف', icon: 'mdi-delete', color: 'error'},
            ];
            return actions;
        },
        ...GlobalComputed,
    },
    watch: {
        files(files){
            this.filesItems = files.data;
        }
    },
    methods: {
        ...GlobalMethods,
        loadMore(payload){
            const page = payload.page;
            this.$emit('loadMore', page);
        },
        search(query){
            this.$emit('search', query);
        },
        reset(){
            this.$emit('reset');
        },
        addItem(item){
            this.filesItems.unshift(item);
        },
        resetCreateForm(){
            this.newExportFile = {
                name: '',
                file: null,
            };
        },
        openEditDialog(file){
            Object.assign(this.editedItem, file);
            this.editDialog = true;
        },
        resetEditForm(){
            Object.assign(this.editedItem, {
                id: null,
                name: '',
            });
        },
        openUpdateImageDialog(file){
            this.updateImageDialog = true;
            this.updateImageId = file.id;
            this.updateImage = null;
        },
        syncItem(newItem){
            this.filesItems = this.filesItems.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        deleteItem(id){
            this.filesItems = this.filesItems.filter(item=>{
                return item.id !== id;
            })
        },
        editAction(){

        },
        openDeleteDialog(file){
            this.deleteDialog = true;
            this.deleteExportFile = file;
        },

    },
    created(){
        this.filesItems = this.files.data;
    }
}

</script>
